interface SkipLinkProp {
  isSkipLink: boolean;
  setIsSkipLink: (value: boolean) => void;
}

export const SkipLink: React.FC<SkipLinkProp> = ({ isSkipLink, setIsSkipLink }) => {
  return (
    <>
      <a
        href="#main-content"
        onFocus={() => {
          setIsSkipLink(true);
        }}
        onBlur={() => {
          setIsSkipLink(false);
        }}
        style={{
          position: 'absolute',
          top: '0px',
          left: isSkipLink ? '0px' : '-300px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '239px',
          height: '58px',
          borderRight: '1px solid #2C2D3E4D',
          background: '#D3D3D3',
          outline: 'none',
          fontFamily: 'Roboto',
          fontSize: '14px',
          color: '#000000',
        }}
      >
        Przejdź do głównej sekcji strony
      </a>
    </>
  );
};
